import { createContext, useContext } from 'react';

import type { PageBlock } from '@/types/block';
import type { PageSectionComponentProps } from './types';

export interface PageSectionContextValue {
  /** Persisted section id (server). */
  sectionId: string;
  /**
   * Editor render key used by the block editor and selection store (`editorSectionId` / `getSectionUiKey`).
   * Matches `section.uiKey ?? section.id`. Not the persisted cross-version `stableId`.
   */
  editorSectionUiKey: string;
  renderMode: 'default' | 'template_preview' | 'layout_preview';
  props?: Record<string, unknown>;
  variant?: string;
  blocks?: PageBlock[];
}

export const PageSectionContext = createContext<PageSectionContextValue | null>(null);

export function usePageSectionContext(): PageSectionContextValue | null {
  return useContext(PageSectionContext);
}

export function usePageSectionData<
  TProps = Record<string, unknown>,
>(): PageSectionComponentProps<TProps> {
  const ctx = useContext(PageSectionContext);
  if (!ctx) {
    throw new Error('usePageSectionData must be used within a PageSectionContext.Provider');
  }
  return { props: (ctx.props ?? {}) as unknown as TProps, variant: ctx.variant };
}
